// @ts-strict
import {type WebToCaseFieldConfig} from './types';

// Catches the typo that would otherwise cost a round-trip; ez-rails validates the real format.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const webToCaseFields: WebToCaseFieldConfig[] = [
  {
    id: 'contactName',
    step: 1,
    required: true,
    defaultValue: ctx => ctx.fullName,
  },
  {
    id: 'email',
    step: 1,
    required: true,
    format: {pattern: EMAIL_PATTERN, errorKey: 'components.SupportMessage.errors.invalidEmail'},
    defaultValue: ctx => ctx.email,
  },
  {
    id: 'categoryLevel1',
    step: 1,
    required: true,
  },
  {
    id: 'categoryLevel2',
    step: 2,
    required: true,
  },
  {
    id: 'orderNumbers',
    step: 2,
    required: false,
    visibleWhen: values => values.categoryLevel1 === 'Order',
  },
  {
    id: 'description',
    step: 2,
    required: true,
  },
];
